module.exports = __webpack_public_path__ + "img/18.db79cf18.png";